<div>
    <h2>{{'usuarios.auditor.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'usuarios.auditor.filters.name' | translate}}</label>
                <input type="text" formControlName="des">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'usuarios.auditor.modal.entidad' | translate}}</label>
                <app-filterable-list [itemsList]="entidades" [selectedItem]="filtersForm.get('entidadControl')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio" (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin" (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="alignment-start-filters">
                <checkbox [id]="'habilitado'" [initialStatus]="''" [initialRefresh]="refreshCheckbox_habilitado" [label]="'usuarios.auditor.filters.habilitado'"
                (refresh)="this.refreshCheckbox_habilitado = false" (formValue)="this.filtersForm.get('habilitado').patchValue($event)" (pristine)="pristineCheckbox('habilitado', $event)"></checkbox>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="alignment-start-filters">
                <checkbox [id]="'permisoEscritura'" [initialStatus]="'true'" [initialRefresh]="refreshCheckbox_permisoEscritura" [label]="'usuarios.auditor.filters.permisoEscritura'"
                (refresh)="this.refreshCheckbox_permisoEscritura = false" (formValue)="this.filtersForm.get('permisoEscritura').patchValue($event)" (pristine)="pristineCheckbox('permisoEscritura', $event)"></checkbox>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="radio-group move-left-small move-left">
                <input type="radio" id="insercion" value="false" formControlName="dateType">
                <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
                <input type="radio" id="actualizacion" value="true" formControlName="dateType">
                <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'"></div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons">
      <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="multi-icon"></th>
                        <!-- <th class="string">{{'usuarios.auditor.table.id' | translate}}</th> -->
                        <th class="string sortable" (click)="toOrderBy('x=> x.ApplicationUser.Nombre', 2)">
                          {{'usuarios.auditor.table.nombre' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.ApplicationUser.Nombre')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.ApplicationUser.Apellido', 3)">
                          {{'usuarios.auditor.table.apellido' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.ApplicationUser.Apellido')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.EntidadControl.Des', 4)">
                          {{'usuarios.auditor.table.entidad' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.EntidadControl.Des')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.ApplicationUser.UserName', 5)">
                          {{'usuarios.auditor.table.username' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.ApplicationUser.UserName')"></i></div>
                        </th>
                        <th class="date sortable" (click)="toOrderBy('x=> x.fechaIns', 6)">
                          {{'global.fecha.insercionShort' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.fechaIns')"></i></div>
                        </th>
                        <th class="date sortable" (click)="toOrderBy('x=> x.fechaUpd', 7)">
                          {{'global.fecha.actualizacionShort' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.fechaUpd')"></i></div>
                        </th>
                        <th class="icon">{{'usuarios.auditor.table.permisoEscritura' | translate}}</th>
                        <th class="multi-actions-bigSubtable">
                            <i class="fas fa-plus" *ngIf="this.role === 'Administrador'" (click)="create()" title="{{'usuarios.auditor.tituloNew' | translate}}"></i>
                            <i class="fa-solid fa-address-card" title="{{'titles.enviarInvitacion' | translate}}" *ngIf="this.claims && this.claims.includes('D_AUD_SendInv')" (click)="sendInvitation()"></i>
                        </th>
                    </tr>
                </thead>
                <tbody *ngFor="let auditor of auditores; trackBy: trackByUserName">
                    <tr>
                        <td class="multi-icon">
                            <i class="fas fa-sm fa-user-lock" *ngIf="!auditor.applicationUser.activo" title="{{'titles.usuarioDesactivado' | translate}}"></i>
                        </td>
                        <!-- <td class="string">{{auditor.applicationUserId}}</td> -->
                        <td class="string-overflow" title="{{auditor.applicationUser.nombre ? auditor.applicationUser.nombre : 'NO INDICADO'}}">{{auditor.applicationUser.nombre ? auditor.applicationUser.nombre : 'NO INDICADO'}}</td>
                        <td class="string">{{auditor.applicationUser.apellido ? auditor.applicationUser.apellido : 'NO INDICADO'}}</td>
                        <td class="string">{{auditor.desEntidadControl}}</td>
                        <td class="string-overflow" title="{{auditor.userName}}">{{auditor.userName}}</td>
                        <td class="date">{{auditor.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="date">{{auditor.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="icon">
                            <i [ngClass]="(auditor.permisoEscritura) ? 'fa-regular fa-circle-check' : 'fa-regular fa-circle-xmark'"
                               [ngStyle]="{color: (auditor.permisoEscritura) ? '' : 'red'}"
                               title="{{(auditor.permisoEscritura ? ('titles.permisoEscritura' | translate) : ('titles.sinPermisoEscritura' | translate))}}"></i>
                        </td>
                        <td class="multi-actions-bigSubtable">
                            <i [ngClass]="auditor.applicationUser.activo ? 'fa-solid fa-lock-open': 'fa-solid fa-lock'" app-click-stop-propagation
                                *ngIf="(this.role === 'Administrador' || (this.claims && this.claims.includes('D_AUD_Lock')))" (click)="block(auditor)"
                                title="{{auditor.applicationUser.activo ? ('titles.usuarioActivado' | translate) : ('titles.usuarioDesactivado' | translate)}}"></i>
                            <i class="fas fa-pencil-alt" *ngIf="(this.role === 'Administrador' || (this.claims && this.claims.includes('AUD_Upd_UserYAlertas')))"
                                [ngClass]="{'disabled': (!auditor.registroEditable)}" (click)="update(auditor)" title="{{'titles.editar' | translate}}"></i>
                            <i class="far fa-trash-alt" *ngIf="this.role === 'Administrador'" [ngClass]="{'disabled': (auditor.registroEnUso)}" app-click-stop-propagation
                                title="{{'titles.eliminar' | translate}}" (click)="askDelete(auditor)"></i>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!auditores || (auditores && auditores.length < 1)">
                    <tr>
                        <td colspan="8">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="auditores && auditores.length > 0" [itemsPerPage]="itemsPerPage"
        [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
        (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event;showWarning=$event">
    </app-toast>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{auditorId ? ('usuarios.auditor.tituloEdit' | translate) : ('usuarios.auditor.tituloNew' | translate)}}</h4>
        </header>
        <app-auditores-new-edit [auditorId]="auditorId" [applicationUserId]="applicationUserId" (refresh)="refresh($event)" (mensaje)="pushMessage($event)"></app-auditores-new-edit>
    </div>
</div>
<div class="modal" *ngIf="sendInvitationModal">
    <div class="modal-content">
      <header>
        <h4>{{ 'global.enviarInvitacion' | translate }}</h4>
      </header>
      <app-send-invitation-aud (refresh)="refresh($event)" (mensaje)="pushMessage($event)"></app-send-invitation-aud>
    </div>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
      <header>
        <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
      </header>
      <content>
        <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
      </content>
      <footer>
        <button class="secondary" (click)="close()">{{ 'global.cancelar' | translate }}</button>
        <button (click)="delete()">{{ 'global.confirmar' | translate }}</button>
      </footer>
    </div>
</div>
